import CaretDownIcon from "@infinitaslearning/pixel-icons/CaretDown";
import inputBaseClasses from "@mui/material/InputBase/inputBaseClasses";
import outlinedInputClasses from "@mui/material/OutlinedInput/outlinedInputClasses";
import selectClasses from "@mui/material/Select/selectClasses";
import nativeSelectClasses from "@mui/material/NativeSelect/nativeSelectClasses";
import inputAdornmentClasses from "@mui/material/InputAdornment/inputAdornmentClasses";
import inputLabelClasses from "@mui/material/InputLabel/inputLabelClasses";
import formHelperTextClasses from "@mui/material/FormHelperText/formHelperTextClasses";
import chipClasses from "@mui/material/Chip/chipClasses";
import { chipMinHeight } from "../Chip/Chip.theme";
export const MuiSelectTheme = (dt) => {
    return {
        defaultProps: {
            IconComponent: CaretDownIcon,
        },
        styleOverrides: {
            root: {
                columnGap: dt.inline.small,
                [`.${inputBaseClasses.input}`]: {
                    height: dt.input.default,
                },
                [`.${outlinedInputClasses.notchedOutline}`]: {
                    top: "0",
                    borderColor: dt.color.outline,
                    borderRadius: dt.input.shape.borderRadius,
                    borderStyle: "solid",
                    borderWidth: dt.input.shape.border,
                    legend: {
                        position: "fixed",
                        left: "-999rem",
                        top: "-999rem",
                    },
                },
                ".PixelIcon:not([class*='MuiSvgIcon-color'])": {
                    backgroundColor: dt.color.onSurface.variant,
                },
                "& > .PixelIcon": {
                    width: dt.icon.size.medium,
                    height: dt.icon.size.medium,
                },
                [`&:hover .${outlinedInputClasses.notchedOutline}, &:is(.Pxl-demo-hover, [data-demostate=hover]) .${outlinedInputClasses.notchedOutline}`]: {
                    borderColor: dt.color.onSurface.key,
                },
                [`&.Mui-focused .${outlinedInputClasses.notchedOutline}, &:is(.Pxl-demo-focus, [data-demostate=focus]) .${outlinedInputClasses.notchedOutline}`]: {
                    borderColor: dt.cta.outlined.color.border.primary.focus,
                    borderWidth: dt.input.shape.border,
                    boxShadow: dt.state.focus.primary,
                },
                [`.${selectClasses.select}[class][class]`]: {
                    minHeight: dt.input.default,
                    paddingLeft: dt.inset.squish.medium.horizontal,
                    paddingRight: dt.inset.squish.medium.horizontal,
                },
                [`.${selectClasses.icon}`]: {
                    top: "unset",
                    width: dt.icon.size.medium,
                    height: dt.icon.size.medium,
                },
                [`* + .${selectClasses.select}[class][class]`]: {
                    // :first-child is a more efficient selector but currently results in security warnings in the browser console.
                    paddingLeft: 0,
                },
                [`.${outlinedInputClasses.input}`]: {
                    display: "inline-block",
                    width: "100%",
                    borderRight: `${dt.icon.size.large} solid transparent`,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    height: dt.input.default,
                    lineHeight: dt.input.default,
                    color: dt.color.onSurface.variant,
                    backgroundColor: dt.color.surface.key,
                    ".MuiBox-root": {
                        alignContent: "center",
                    },
                },
                [`select.${nativeSelectClasses.select}[class]`]: {
                    [`&.${nativeSelectClasses.multiple}`]: {
                        height: "auto",
                        overflow: "auto",
                        borderRightWidth: 0,
                        paddingRight: 0,
                    },
                    option: {
                        padding: "5px",
                    },
                },
                [`.${inputAdornmentClasses.root}`]: {
                    marginRight: 0,
                },
                [`.${inputLabelClasses.root} + &`]: {
                    marginTop: dt.stacked.xSmall,
                },
                [`& + .${formHelperTextClasses.root}`]: {
                    marginTop: dt.stacked.xSmall,
                },
                [`.${selectClasses.multiple}[class][class]`]: {
                    height: "auto",
                },
                ".MuiBox-root": {
                    // Deprecated
                    minHeight: dt.input.default,
                    paddingTop: dt.inset.squish.medium.vertical,
                    paddingBottom: dt.inset.squish.medium.vertical,
                    columnGap: dt.inline.xSmall,
                    rowGap: dt.inline.xSmall,
                },
                ".Pxl-Select-MultipleWrapper": {
                    minHeight: dt.input.default,
                    paddingTop: dt.inset.squish.medium.vertical,
                    paddingBottom: dt.inset.squish.medium.vertical,
                },
                [`&.${selectClasses.disabled}`]: {
                    [`.${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: dt.cta.outlined.color.border.primary.disabled,
                    },
                    [`.${outlinedInputClasses.input}`]: {
                        color: dt.cta.contained.color.text.primary.disabled,
                    },
                },
                [`&.${inputBaseClasses.sizeSmall}`]: {
                    [`.${selectClasses.select}[class][class]`]: {
                        minHeight: dt.input.dense,
                    },
                    [`.${outlinedInputClasses.input}`]: {
                        height: dt.input.dense,
                        lineHeight: dt.input.dense,
                    },
                    ".MuiBox-root": {
                        // Deprecated
                        minHeight: dt.input.dense,
                        paddingTop: dt.inset.squish.small.vertical,
                        paddingBottom: dt.inset.squish.small.vertical,
                        columnGap: dt.inline.xSmall,
                        rowGap: dt.inline.xSmall,
                    },
                    ".Pxl-Select-MultipleWrapper": {
                        minHeight: dt.input.dense,
                        paddingTop: dt.inset.squish.small.vertical,
                        paddingBottom: dt.inset.squish.small.vertical,
                    },
                },
                [`.${chipClasses.root}`]: {
                    height: `${chipMinHeight.medium}px`,
                    [`&.${chipClasses.sizeSmall}`]: {
                        height: `${chipMinHeight.small}px`,
                    },
                },
            },
        },
    };
};
